<template>
  <div class="mt-12">
    <div class="card bg-white rounded-xl p-4 ">
      <div class="relative">
        <div class="card top_primary_card bg-primary font-bold text-white p-4 rounded-xl absolute -top-11 w-full">
          Job Categories ({{jobCategories.length}})
        </div>
      </div>
      <div class="mt-8">
        <div class="flex flex-wrap justify-between items-center">
          <div class="w-72 mb-4">
          </div>
          <div class="mb-4">
            <Button @buttonAction="addNewCust(false)" :btnSize="'large'" :textColor="'white'" :btnColor="'primary'" :btnText="'Add Job Category'"/>
          </div>
        </div>
      </div>
      <div>
        <div style="overflow-y: auto; white-space: nowrap;" class="" v-if="jobCategories.length > 0">
          <div v-for="(data, index) in jobCategories" :key="index"  class="cust_card m-2  heading-3 border-b border-gray1  bg-white  text-sm px-3 py-3 items-center hover:bg-gray1 cursor-pointer" @click="openDetail(data.jobCategoryId, data)">
            <div class="flex items-center justify-between">
              <p class="text-gray4 heading-5" style="font-weight: bold;">{{data.categoryName}}
              </p>
            </div>
          </div>
        </div>
        <div v-else>
          <NoRecords :alertMessage="`No records found.`" />
        </div>
      </div>
    </div>
    <add-edit-tax v-if="addJobCategory" :jobCategoryId="selectedCatId" :JCDetail="selectedDetail" />
   </div>
</template>
<script>
import NoRecords from '@/View/components/noRecords.vue'
import MyJobApp from '@/api/MyJobApp.js'
import Button from '@/View/components/globalButton.vue'
import AddEditTax from './addEditJC.vue'
export default {
  components: {
    NoRecords,
    Button,
    AddEditTax
  },
  data() {
    return {
      jobCategories: [],
      searchForLead: '',
      addJobCategory: false,
      totalCount: 0,
      selectedCatId: 0,
      selectedDetail: {}
    };
  },
  created() {},
  mounted() {
    document.body.style = 'overflow: visible;'
    this.getJobCategoryList()
    this.$root.$on("addNewJobCategoryComponennt", (response) => {
      console.log(response);
      if (response) {
        this.getJobCategoryList()
        this.addJobCategory = false
      }
      this.addJobCategory = false
    });
  },
  beforeDestroy() {
    this.$root.$off('addNewJobCategoryComponennt')
  },
  methods: {
    openDetail (jobCategoryId, data) {
      this.selectedCatId = jobCategoryId
      this.selectedDetail = data
      this.addJobCategory= true
    },
    addNewCust () {
      this.selectedCatId = 0
      this.selectedDetail = {}
      this.addJobCategory= true
    },
    getJobCategoryList () {
    this.$store.dispatch('SetLoader', {status: true, message: 'Loading...'})
      MyJobApp.JobCategoryList(
          response => {
            this.jobCategories = response.Data !== null ? response.Data : []
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          },
          () => {
            this.$store.dispatch('SetLoader', {status: false, message: ''})
          }
        )
    }
  },
};
</script>
<style scoped>
.lead_name_col {
  min-width: 280px !important;
  width: 280px !important;
  overflow-wrap: anywhere;
  white-space: pre-wrap;
  padding-right: 8px;
}
</style>